// @ts-nocheck
import { destroy, flow, getRoot, Instance, types } from 'mobx-state-tree';
import { User } from './models/User';
import { getEnvironment } from './utils';
import { getBaseStore } from './BaseStore';
import { Page } from '../common/enums';
import { RootStoreType } from './RootStore';

export const SearchUserCriteria = types.model({
  userId: types.maybeNull(types.number),
  firstName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  userName: types.maybeNull(types.string),
  email: types.maybeNull(types.string),
  isActive: types.maybeNull(types.boolean),
  secretariatId: types.maybeNull(types.number),
});

export const UserStore = types
  .compose(
    getBaseStore<Instance<typeof User>, Instance<typeof User>>(User, 'userId', 'user'),
    types.model('UserStore', {}),
  )
  .actions((self: any) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);
    const apiFetcher = env.api;

    const getWithRole = flow(function* () {
      const res = yield env.api.get(`user/GetAllWithRole`);
      self.setDatasFromArray(res);
    });

    const saveUser = flow(function* (user: Instance<typeof User>) {
      console.log('Saving user...');
      const res = yield self.saveElement(user);
      // @ts-ignore
      if (user.userId !== res.userId) {
        // @ts-ignore
        root.ApplicationStore.navigate(`${Page.UserPage}/${res.userId}`);
      }
    });

    const deleteUsers = flow(function* (ids: number[]) {
      yield apiFetcher.deleteList('user', ids);
      ids.forEach((id) => {
        const user = self.getById(id + '');
        if (user) {
          destroy(user);
        }
      });
    });

    const search = flow(function* (criteria: Instance<typeof SearchUserCriteria>) {
      const result = yield apiFetcher.get('user', {
        params: criteria,
      });
      const resultUser: Array<Instance<typeof User>> = self.putInStore(result);

      return resultUser;
    });

    const searchWithRoles = flow(function* (criteria: Instance<typeof SearchUserCriteria>) {
      const resultUserDetails = yield apiFetcher.get('user/SearchWithRoles', {
        params: criteria,
      });

      return resultUserDetails as User[];
    }) as (criteria: Instance<typeof SearchUserCriteria>) => Promise<User[]>;

    return { getWithRole, saveUser, deleteUsers, search, searchWithRoles };
  });


export type userStoreType = Instance<typeof UserStore>;
